export enum FlightType {
  OneWay = 'one-way',
  Round = 'round',
}
